module.exports = __webpack_public_path__ + "img/s22.0c87bb6.png";